import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import TimesheetLinesCont from '../../../components/People/Timesheet/Lines/TimesheetLinesCont'
import TimesheetForm from '../../../components/People/Timesheet/TimesheetForm'
import TimesheetSummary from '../../../components/People/Timesheet/TimesheetSummary'
import CustomSpin from '../../../elements/CustomSpin'
import style from '../../../components/Sales/style.css'
import Status from '../../../elements/Status'
import {strVal} from '../../../modules/Utils'
import React, {Fragment, useState} from 'react'
import {Modal, Popconfirm, Row, Tabs} from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import _ from 'lodash'

const {TabPane} = Tabs

function TimesheetModal(props) {
  const {
    visible,
    modalType,
    submitting,
    approve,
    submit,
    update,
    formRef,
    onCancel,
    approving,
    removing,
    remove,
    timesheet,
    actions,
    handleActions,
    fetchingActions,
  } = props

  const isNew = modalType === 'new'
  const [_rev, setRev] = useState(new Date().getTime())

  const Operations = ({timesheet, ...rest}) => {
    const ops = actions
      .filter(a => a.key !== 'update' && a.key !== 'remove')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [
              prev,
              <span className="ant-divider" />,
              curr,
            ])
          : []}
      </div>
    )
  }

  return (
    <Modal
      visible={visible}
      title={'Timesheet'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          approve={approve}
          submit={submit}
          update={update}
          submitting={submitting}
          approving={approving}
          title={'Product'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <CustomSpin spinning={fetchingActions}>
        <h3 className={style.title}>
          {!isNew && (
            <Fragment>
              <Status value={_.capitalize(timesheet.status)} />
              <Operations
                style={{marginTop: '10px'}}
                timesheet={timesheet}
                status={strVal(timesheet, 'status')}
              />
            </Fragment>
          )}
        </h3>
      </CustomSpin>
      <Tabs
        defaultActiveKey="form"
        onChange={() => setRev(new Date().getTime())}>
        <TabPane tab="Form" key="form">
          <Row>
            <TimesheetForm ref={formRef} {...props} />
          </Row>
        </TabPane>
        <TabPane disabled={isNew} tab={'Lines'} key="#lines">
          <TimesheetLinesCont timesheet={timesheet} />
        </TabPane>
        <TabPane disabled={isNew} tab={'Summary'} key="#summary">
          <TimesheetSummary key={_rev} {...props} />
        </TabPane>
        <TabPane disabled={isNew} tab="Files" key="files">
          <DocumentsCont
            editable={true}
            footer={false}
            category={false}
            owner={timesheet}
          />
        </TabPane>
      </Tabs>
    </Modal>
  )
}

TimesheetModal.propTypes = {}
TimesheetModal.defaultProps = {}

export default TimesheetModal
